module.exports = __webpack_public_path__ + "img/12.de82b596.jpg";